import { useState, useEffect } from "react"
import axios from "axios"
import useLocalStorageState from "use-local-storage-state"
import HeroCarousel from "./components/HeroCarousel"
import CategoryRow from "./components/CategoryRow"
import FavoritesRow from "./components/FavoritesRow"
import MovieView from "./components/MovieView"
import Footer from "./components/Footer"
import editorsChoiceCollection from "./data/editors-choice-collection"

const API_KEY = process.env.REACT_APP_TMDB_API_KEY
const BASE_URL = "https://api.themoviedb.org/3/discover/movie"

const CATEGORIES = [
  // { id: "editors",   name: "Featured",          params: null, static: editorsChoiceCollection },
  { id: "popular",   name: "Popular",           params: "&sort_by=popularity.desc" },
  { id: "action",    name: "Action",            params: "&with_genres=28" },
  { id: "scifi",     name: "Sci-Fi",            params: "&with_genres=878" },
  { id: "adventure", name: "Adventure",         params: "&with_genres=12" },
  { id: "crime",     name: "Crime",             params: "&with_genres=80" },
  { id: "drama",     name: "Drama",             params: "&with_genres=18" },
  { id: "horror",    name: "Horror",            params: "&with_genres=27" },
]

async function fetchCategory(cat) {
  if (cat.static) return { id: cat.id, movies: cat.static }
  const url = `${BASE_URL}?api_key=${API_KEY}&language=en-US${cat.params}`
  const res = await axios.get(url)
  return { id: cat.id, movies: res.data.results }
}

function App() {
  const [categories, setCategories] = useState({})  // { id: [movies] }
  const [currentMovie, setCurrentMovie] = useState(null)
  const [loading, setLoading] = useState(true)

  const [likedMovies] = useLocalStorageState("likedMovies", { defaultValue: [] })

  useEffect(() => {
    Promise.allSettled(CATEGORIES.map(fetchCategory)).then((results) => {
      const data = {}
      results.forEach((result) => {
        if (result.status === "fulfilled") {
          data[result.value.id] = result.value.movies
        }
      })
      setCategories(data)
      setLoading(false)
    })
  }, [])

  const handleMovieClick = (movie) => {
    setCurrentMovie(movie)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleBack = () => {
    setCurrentMovie(null)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const popularMovies = categories["popular"] || []
  const heroMovies = popularMovies.slice(0, 5)

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      {currentMovie ? (
        <MovieView
          movie={currentMovie}
          onBack={handleBack}
          onMovieClick={handleMovieClick}
          popularMovies={popularMovies}
        />
      ) : (
        <>
          {loading ? (
            <div className="flex items-center justify-center h-screen">
              <div className="w-8 h-8 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : (
            <>
              <HeroCarousel movies={heroMovies} onMovieClick={handleMovieClick} />

              <div className="pb-10">
                <FavoritesRow
                  movies={[...likedMovies].reverse()}
                  onMovieClick={handleMovieClick}
                  currentMovie={currentMovie}
                />

                {CATEGORIES.map((cat) => (
                  <CategoryRow
                    key={cat.id}
                    label={cat.name}
                    movies={categories[cat.id] || []}
                    onMovieClick={handleMovieClick}
                    currentMovie={currentMovie}
                  />
                ))}
              </div>
            </>
          )}
          <Footer />
        </>
      )}
    </div>
  )
}

export default App
